import styled from '@emotion/styled'
import { Link } from 'react-router-dom'
import { ArrowRight } from 'components/icons'
import { Body } from 'components'
import { isMobile } from 'react-device-detect'

const SeeMoreLinkView = styled.div<{ isHeader?: boolean }>`
  flex-grow: 0;
  flex-shrink: 0;

  a {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    text-align: right;
    text-decoration: none;
    color: ${(props) => props.theme.links.dark.color};
    &:hover,
    &:active {
      color: ${(props) => props.theme.links.dark.hover};
      @media (max-width: ${(props) => props.theme.breakpoints.mobile}) {
        color: ${(props) => props.theme.links.dark.color};
      }
    }
  }
`

const SeeMoreLinkText = styled(Body)<{ isHeader?: boolean }>`
  display: block;
  line-height: 1;
  transition: ${(props) => props.theme.links.transition};
  color: ${(props) => props.theme.links.dark.color};
  font-size: ${(props) => props.theme.fonts.sizes.small};
  @media (max-width: ${(props) => props.theme.breakpoints.mobile}) {
    font-size: ${(props) => props.theme.fonts.sizes.xSmall};
  }

  a:hover &,
  a:active & {
    color: ${(props) => props.theme.links.dark.hover};
    @media (max-width: ${(props) => props.theme.breakpoints.mobile}) {
      color: ${(props) => props.theme.links.dark.color};
    }
  }
`

const SeeMoreLinkArrow = styled.div`
  margin: 0 0 0 0.3rem;
  display: flex;
`

const SeeMoreLink = ({
  text,
  to,
  isHeader = false,
}: {
  text?: string
  to: string
  isHeader?: boolean
}) => (
  <SeeMoreLinkView isHeader={isHeader}>
    <Link to={to}>
      <SeeMoreLinkText isHeader={isHeader}>{text}</SeeMoreLinkText>
      <SeeMoreLinkArrow>
        <ArrowRight strokeWidth={2} size={isMobile ? 16 : 18} />
      </SeeMoreLinkArrow>
    </Link>
  </SeeMoreLinkView>
)

export default SeeMoreLink
